import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoleService } from '../../services/role.service';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn, ReactiveFormsModule } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { MaterialModule } from '../../../material/material.module';

@Component({
  selector: 'app-user-role-assign-dialog',
  templateUrl: './user-role-assign-dialog.component.html',
  styleUrls: ['./user-role-assign-dialog.component.scss'],
})
export class UserRoleAssignDialogComponent implements OnInit {
  assignRoleForm!: FormGroup;
  userNotInRoles!: string[];

  constructor(public dialogRef: MatDialogRef<UserRoleAssignDialogComponent>,
    private fb: FormBuilder,
    private roleService: RoleService,
    private userService: UserService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.assignRoleForm = this.fb.group({
      roleName: ['', [Validators.required, this.forbiddenNamesValidator()]]
    });

    this.roleService.getByUserNotInRole(this.data.userId).subscribe(response => {
      this.userNotInRoles = response;
    });
  }
  submit() {
    if (this.assignRoleForm.valid) {
      this.userService.postUsersInRole(this.data.userId, this.roleName?.value).subscribe(response => {
        if (response) {
          this.dialogRef.close();
        }
      });
    }
  }

  removeRole(roleName: string) {
    this.userService.postUsersInRole(this.data.userId, roleName).subscribe(response => {
      if (response) {
        this.dialogRef.close();
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }


  public get roleName(): AbstractControl | null {
    return this.assignRoleForm.get('roleName');
  }

  forbiddenNamesValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const index = this.userNotInRoles?.findIndex(role => {
        return (new RegExp('\^' + role?.toLowerCase() + '\$')).test((control.value as string)?.toLowerCase());
      });

      return index < 0 ? { 'forbiddenNames': { value: control.value } } : null;
    };
  }
}
